import {Inject, Injectable} from '@angular/core';
import {BaseService} from './base-service';
import {CustomerArea} from '../_models/customer-area';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {LibConfig, LibConfigService} from '../lib.config';

@Injectable({
    providedIn: 'root'
})
export class CustomerAreaService extends BaseService<CustomerArea> {
    destination = 'customer-areas';

    public customerArea: Observable<CustomerArea>;
    private customerAreaSubject: BehaviorSubject<CustomerArea>;

    constructor(
        http: HttpClient,
        @Inject(LibConfigService) config: LibConfig
    ) {
        super(http, config);
        this.customerAreaSubject = new BehaviorSubject<CustomerArea>(null);
        this.customerArea = this.customerAreaSubject.asObservable();
    }

    findByPickupLocationId(pickupLocationId: number) {
        return this.http.get(`${this.baseUrl()}/pickup-locations/${pickupLocationId}`);
    }

    setCustomerArea(value: CustomerArea) {
        this.customerAreaSubject.next(value);
    }

    public get customerAreaValue(): CustomerArea {
        return this.customerAreaSubject.getValue();
    }
}
